import { render, staticRenderFns } from "./GroupTagCreated.vue?vue&type=template&id=22d560ba&scoped=true"
import script from "./GroupTagCreated.vue?vue&type=script&lang=js"
export * from "./GroupTagCreated.vue?vue&type=script&lang=js"
import style0 from "./GroupTagCreated.vue?vue&type=style&index=0&id=22d560ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d560ba",
  null
  
)

export default component.exports